<div class="activity-timeline">
  <div *ngIf="loading" class="loading"><app-loading></app-loading></div>
  <div *ngIf="!loading && activityEntries.length === 0" class="no-activity">
    {{ commonText.no_data_found }}
  </div>

  <div *ngIf="!loading && activityEntries.length > 0" class="timeline">
    <div *ngFor="let entry of activityEntries; let last = last" class="timeline-entry" [class.last]="last">
      <!-- User Avatar -->
      <div class="timeline-avatar">
        <div class="avatar" [class.avatar-compliance]="entry.entityType === 'compliance'">{{ getInitials(entry.user) }}
        </div>
      </div>

      <!-- Entry Content -->
      <div class="timeline-content">
        <!-- Header -->
        <div class="entry-header">
          <span class="user-name">{{ entry.user?.first_name }} {{ entry.user?.last_name }}</span>
          <span class="action-text" *ngIf="entry.type === 'comment'">commented</span>
          <span class="action-text" *ngIf="entry.type === 'change'">updated</span>
          <!-- Entity type badge (only shown in compliance mode) -->
          <span *ngIf="historyType === 'compliance'" class="entity-badge"
            [class.entity-badge--action]="entry.entityType === 'action'"
            [class.entity-badge--compliance]="entry.entityType === 'compliance'">
            {{ entry.entityType === 'compliance' ? 'REVIEW' : 'ACTION' }}
          </span>
          <span class="timestamp">{{ getRelativeTime(entry.timestamp) }}</span>
        </div>

        <!-- Comment Content -->
        <div *ngIf="entry.type === 'comment'" class="comment-box">
          <p class="comment-text">{{ entry.comment }}</p>
        </div>

        <!-- Changes Content -->
        <div *ngIf="entry.type === 'change' && entry.changes" class="changes-box">
          <div *ngFor="let change of entry.changes" class="change-item">
            <strong>{{ change.field }}</strong>
            <div *ngIf="change.type === 'file' && change.files" class="file-changes">
              <div *ngFor="let file of change.files" class="file-item">
                <span class="file-name">{{ file.file_name }}</span>
                <span class="file-action" [class.added]="file.action === 'added'"
                  [class.removed]="file.action === 'removed'">
                  {{ file.action }}
                </span>
                <button mat-icon-button class="download-btn" (click)="downloadHistoryFile(actionId!, file.id)"
                  matTooltip="Download file" type="button">
                  <mat-icon>cloud_download</mat-icon>
                </button>
              </div>
            </div>
            <div *ngIf="change.type !== 'file'" class="change-values">
              <span class="old-value" *ngIf="change.oldValue">{{
                change.oldValue
                }}</span>
              <mat-icon *ngIf="change.oldValue && change.newValue" class="arrow-icon">arrow_forward</mat-icon>
              <span class="new-value" [class.multiline-comment]="change.field === 'Comment'" *ngIf="change.newValue">{{
                change.newValue
                }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>